import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Address, AddressDTO } from '../../../../core/models/address.interface';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { FormUtils } from '../../../../shared/utils';
import { AddressService } from '../../../../core/services/address/address-service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-address-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './address-form.html',
  styleUrl: './address-form.scss',
})
export class AddressForm {
  address: string | null = null;
  errorMsg: string[] | null = null;
  addressSelected: Address | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<AddressForm>,
    private toastr: ToastrService,
    private serviceAddress: AddressService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.serviceAddress.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceAddress.selectedaddress$.subscribe((address) => {
      if (address) {
        this.address = String(address.id);
        this.addressSelected = address;
        this.addressForm.patchValue({
          ...address,
        });
      }
    });
  }

  addressForm = this.formBuilder.group({
    street: ['', [Validators.required, Validators.maxLength(100)]],
    number: ['', [Validators.required, Validators.maxLength(10)]],
    complement: ['', [Validators.required, Validators.maxLength(100)]],
    territoryCode: ['', [Validators.required, Validators.maxLength(10)]],
    territory: ['', [Validators.required, Validators.maxLength(100)]],
    authorityCode: ['', [Validators.required, Validators.maxLength(10)]],
    authority: ['', [Validators.required, Validators.maxLength(100)]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  saveAddress() {
    const payload = this.addressForm.value as AddressDTO;
    if (this.addressForm.status === 'VALID' && !this.address) {
      this.loadingService.show(true);
      this.serviceAddress.createAddress(payload).subscribe({
        next: (address) => {
          this.loadingService.show(false);
          const msg = `La dirección ${address.street} fue CREADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.addressForm.status === 'VALID' && this.address) {
      this.loadingService.show(true);
      const id = Number(this.address);
      this.serviceAddress.UpdateAddress(id, { ...payload, id: id }).subscribe({
        next: (address) => {
          this.loadingService.show(false);
          const msg = `La dirección ${address.street} fue EDITADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
